import { MsalService } from '@azure/msal-angular';

export const checkAndSetActiveAccount = (authService: MsalService): void => {
  const activeAccount = authService.instance.getActiveAccount();
  if (!activeAccount && authService.instance.getAllAccounts().length > 0) {
    const accounts = authService.instance.getAllAccounts();
    authService.instance.setActiveAccount(accounts[0]);
  }
};
